<template>
  <!-- <b-card-code :title="$t('user.mobile')"> -->
  <div>
    <b-form
        ref="form"
        :style="{ height: trHeight }"
        class="mt-0"
        @submit.prevent="repeatAgain"
    >
      <!-- :style="{ height: trHeight }" -->
      <!-- Row Loop -->
      <b-row v-for="(mobile, index) in mobiles" :key="index" ref="row">
        <b-col xl="2" lg="2" sm="4">
          <b-form-group
              :label="$t('user.dialCode')"
              :label-for="`admission-mobile-dialcode${index}`"
          >
            <my-v-select
                :key="mobiles[index].countryId"
                :id="`admission-mobile-dialcode${index}`"
                v-if="countries"
                v-model="mobiles[index].countryId"
                :multiple="false"
                :options="countries.length ? countries : []"
                :translate="false"
                :concat-label="['title.fa', 'phoneCode']"
                :reduce-field="['_id']"
                :searchable="true"
                :filterable="true"
            />

          </b-form-group>
        </b-col>
        <!-- Item Mobile -->
        <b-col xl="2" lg="3" sm="5">
          <b-form-group
              :invalid-feedback="
              invalidFeedbackMobile(index)
                ? $t(`validation.${invalidFeedbackMobile(index)}`, {
                    field: $t('user.anotherMobile'),
                    min : 11
                  })
                : ''
            "
              :label="$t('user.anotherMobile')"
              :state="v.mobiles.$each.$iter[index].mobile.$dirty ? ((!v.mobiles.$each.$iter[index].mobile.$invalid === false) ? false : null) : null"
              :label-for="`admission-mobile${index}`"
              :class="{'required-group' : !v.mobiles.$each.$iter[index].mobile.required}"
          >
            <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
            <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
            <b-form-input
                type="number"
                oninput="if (this.value.length > 11) this.value = this.value.slice(0, 11);"
                :aria-describedby="`admission-mobile-help${index}`"
                v-model="mobiles[index].mobile"
                dir="ltr"
                :state="v.mobiles.$each.$iter[index].mobile.$dirty ? ((!v.mobiles.$each.$iter[index].mobile.$invalid === false) ? false : null) : null"
                :id="`admission-mobile${index}`"

            />
            <b-form-text :id="`admission-mobile-help${index}`">{{
                $t("hint.mobile")
              }}
            </b-form-text>
          </b-form-group>
        </b-col>
        <!-- Remove and Add Button -->
        <b-col>
          <div class="action-buttons has-margin sm">
            <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="white"
                @click="removeItem(index)"
            >
              <b-icon icon="x-circle"
                      variant="danger"
                      scale="2"
              ></b-icon>
            </b-button>
            <b-button

                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="white"
                @click="repeatAgain"
            >
              <b-icon icon="plus-circle"
                      variant="success"
                      scale="2"
              ></b-icon>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
  <!-- 
    <template #code>
      {{ codeBasic }}
    </template> -->
  <!-- </b-card-code> -->
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import mobileValidation from "@/mixins/validations/mobile";
import {required} from "vuelidate/lib/validators";
import {heightTransition} from "@/mixins/ui/transition";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormText,
} from "bootstrap-vue";
import {mapGetters} from "vuex";
import Ripple from "vue-ripple-directive";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
// import { codeBasic } from "./code";

export default {
  components: {
    MyVSelect,
    BCardCode,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormText,
  },
  directives: {
    Ripple,
  },
  props: ["v", "isForeigner"],
  data() {
    return {
      // items: [
      //   {
      //     id: 1,
      //     selected: "male",
      //     selected1: "designer",
      //     prevHeight: 0,
      //   },
      // ],
      nextTodoId: 2,
      // codeBasic,
    };
  },
  mixins: [mobileValidation, heightTransition],
  computed: {
    ...mapGetters({countries: "location/countries"}),
    mobiles: {
      set(mobiles) {
        this.$store.commit("user/SET_MOBILES", mobiles);
      },
      get() {
        return this.$store.getters["user/mobiles"];
      },
    },
    country: {
      set(country) {
        this.$store.commit("user/SET_COUNTRY", country);
      },
      get() {
        return this.$store.getters["user/country"];
      },
    },
    // invalidFeedbackMobile: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.v.mobiles.$each.$iter[index].mobileNumber.$dirty) return error;
    //     if (!this.v.mobiles.$each.$iter[index].mobileNumber.mobileValidation) error = "invalid";
    //     if (!this.v.mobiles.$each.$iter[index].mobileNumber.required) error = "required";
    //     return error;
    //   },
    // },
  },
  mounted() {
    this.initTrHeight();
  },
  watch: {},
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    // preventMobileType(value, index) {
    //     if (this.mobiles[index].mobile.length >= 11) {
    //       value.preventDefault();
    //       return;
    //     }
    // },
    invalidFeedbackMobile(index) {
      let error = "";
      if (!this.v.mobiles.$each.$iter[index].mobile.$dirty) return error;

      if (!this.v.mobiles.$each.$iter[index].mobile.required) {
        error = "required";
        return error;
      }
      if (!this.v.mobiles.$each.$iter[index].mobile.minLength) {
        error = "min";
        return error;
      }
      if (!this.v.mobiles.$each.$iter[index].mobile.mobileValidation) {
        error = "invalid";
        return error;
      }
      return error;
    },
    repeatAgain() {
      this.mobiles.push({mobile: "", countryId: ""});
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      if (index !== 0) {
        this.mobiles.splice(index, 1);
        this.trTrimHeight(this.$refs.row[0].offsetHeight);
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
  // validations() {
  //   return {
  //     mobiles: {
  //       $each: {
  //         mobile_number: {
  //           required,
  //           mobileValidation: (value) => this.mobileValidation(value),
  //         },
  //       },
  //     },
  //   };
  // },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
